import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsVideoComponent } from '@spartacus/core';
import { environment } from '../../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { FaqTrackingService } from '../../../services/faq-tracking.service';
import { ActionType } from '../../../models/global-tracking.model';

@Component({
  selector: 'app-faq-video-popup',
  templateUrl: './faq-video-popup.component.html',
  styleUrl: './faq-video-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FaqVideoPopupComponent implements OnChanges {

  /** Old Implementation
  public componentData: CmsVideoComponent;
  videoUrl: string;
  private unsubscribe$ = new Subject<void>(); */

  /** OOTB Implementation */
  @Input() componentData: CmsVideoComponent;
  videoUrl$: Observable<string>;
  showModal = false;
  @ViewChild('videoPlayer') videoPlayer: ElementRef<HTMLVideoElement>;

  constructor(
    public component: CmsComponentData<CmsVideoComponent>,
    private faqTrackingService: FaqTrackingService,
  ) { }

  /** OOTB Implementation */

  ngOnChanges(): void {
    this.videoUrl$ = of(environment.siteUrls.getBackofficeUrl + this.componentData?.video?.url.replace('/medias', ''));
    this.faqTrackingService.pageLoadTrackingData();
  }

  onVideoClick(event: Event): void {
    const target = event.target as HTMLElement;
    this.faqTrackingService.trackVideoLayerOpen(ActionType.FAQ_VIDEO, target);

    this.videoUrl$ = of(environment.siteUrls.getBackofficeUrl + this.componentData?.video?.url.replace('/medias', ''));
    this.showVideoModal();
  }

  showVideoModal() {
    this.showModal = true;
  }

  stopVideo() {
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      this.videoPlayer.nativeElement.pause();
    }
    this.showModal = false;
  }

  /** Old Implementation
  ngOnInit(): void {
    this.pageService.getComponentData('AccessRequestQ1VideoPopupComponent')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: CmsVideoComponent) => {
        this.videoUrl = environment.siteUrls.getBackofficeUrl + data?.video?.url.replace('/medias', '');
      });
    this.component.data$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.componentData = data;
      });
  }

  ngAfterViewInit(): void {
    const modalElement = this.elRef.nativeElement.querySelector('#closeVideo');
    modalElement.addEventListener('hidden.bs.modal', () => { });
  }

  stopVideo(video) {
    video.pause();
  }

  ngOnDestroy() {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
  } */
}
